<div class="container">
  <mat-card>
    <form [formGroup]="activateCenterForm" (ngSubmit)="submit()">
      <mat-card-content>
        <mat-form-field class="flex-fill" (click)="activationDatePicker.open()">
          <mat-label>{{ 'labels.inputs.Activated On Date' | translate }}</mat-label>
          <input
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="activationDatePicker"
            required
            formControlName="activationDate"
          />
          <mat-datepicker-toggle matSuffix [for]="activationDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #activationDatePicker></mat-datepicker>
          @if (activateCenterForm.controls.activationDate.hasError('required')) {
            <mat-error>
              {{ 'labels.inputs.Activated On Date' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!activateCenterForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
